import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function TransporteurPalettesRungis() {
  useEffect(() => {
    document.title = "Transporteur Palettes Rungis (94) | Coursier, Utilitaire avec Chauffeur, Aide Chargement - Transporteur Express IDF";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF à Rungis (94) : transport palettes MIN de Rungis, location camion utilitaire avec chauffeur, aide au chargement, livraison express marchandises. Devis gratuit 24h/7j !');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'transporteur palettes Rungis, transport palettes MIN Rungis, location camion utilitaire avec chauffeur Rungis, aide au chargement Rungis, coursier Rungis 94, livraison express Rungis, transport marchandises Rungis, utilitaire grand volume Rungis, déménageur Rungis, porteur Rungis, transport Val-de-Marne, livraison urgente 94, transporteur professionnel Rungis, transport frigorifique Rungis');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://transporteurexpressidf.fr/transporteur-palettes-rungis');
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Transporteur Palettes Rungis (94) | Coursier, Utilitaire avec Chauffeur, Aide Chargement');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Transporteur Express IDF à Rungis (94) : transport palettes MIN de Rungis, location camion utilitaire avec chauffeur, aide au chargement, livraison express marchandises. Devis gratuit 24h/7j !');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://transporteurexpressidf.fr/transporteur-palettes-rungis');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Transporteur Palettes Rungis (94) | Coursier, Utilitaire avec Chauffeur, Aide Chargement');
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', 'Transporteur Express IDF à Rungis (94) : transport palettes MIN de Rungis, location camion utilitaire avec chauffeur, aide au chargement, livraison express marchandises. Devis gratuit 24h/7j !');
    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) geoRegion.setAttribute('content', 'FR-94');
    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) geoPlacename.setAttribute('content', 'Rungis, Val-de-Marne');
    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) geoPosition.setAttribute('content', '48.7500;2.3500');
    const icbm = document.querySelector('meta[name="ICBM"]');
    if (icbm) icbm.setAttribute('content', '48.7500, 2.3500');
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
  }, []);

  const faqData = [
    {
      question: "Quels sont vos horaires pour le MIN de Rungis ?",
      answer: "Nous intervenons 24h/24 et 7j/7 au Marché International de Rungis. Nos équipes connaissent parfaitement les horaires d'ouverture du MIN et s'adaptent à vos contraintes professionnelles, notamment pour les livraisons matinales."
    },
    {
      question: "Quels types de palettes transportez-vous ?",
      answer: "Nous transportons tous types de palettes : Europe (80x120cm), standard (100x120cm), palettes perdues, palettes consignées. Nous gérons également les marchandises froides et sèches avec des véhicules adaptés."
    },
    {
      question: "Proposez-vous des tournées régulières pour les professionnels ?",
      answer: "Oui, nous proposons des contrats de tournées régulières B2B avec tarifs dégressifs. Idéal pour les grossistes, restaurateurs et commerçants du MIN de Rungis qui ont des besoins récurrents."
    },
    {
      question: "Quels sont vos tarifs pour le transport de palettes ?",
      answer: "Nos tarifs démarrent à partir de 49€ pour une palette selon la distance et le volume. Pour les tournées régulières, nous proposons des tarifs préférentiels. Contactez-nous pour un devis personnalisé."
    },
    {
      question: "Livrez-vous en dehors de Rungis ?",
      answer: "Absolument ! Nous couvrons tout le Val-de-Marne (94) et l'Île-de-France : Orly, Thiais, Chevilly-Larue, Créteil, et toute la région parisienne. Livraison express garantie."
    }
  ];

  return (
    <>
      <SchemaOrg 
        type="LocalBusiness"
        name="Transporteur Express - Rungis"
        description="Transport de palettes au MIN de Rungis et livraison express dans le Val-de-Marne"
        areaServed="Rungis, Orly, Thiais, Chevilly-Larue, Créteil, Val-de-Marne"
      />

      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-50 via-white to-gray-50 pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/7561754c36e4e230cb4b9af03f450c26.jpg')] bg-cover bg-center opacity-5"></div>
        
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line"></i>
              <span>MIN de Rungis (94) - Val-de-Marne</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
              Transport de Palettes à <span className="text-red-600">Rungis (94)</span> — MIN &amp; Zone Industrielle
            </h1>
            
            <p className="text-lg lg:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
              Vous recherchez un <strong>transporteur de palettes fiable au Marché International de Rungis</strong> ? Nous intervenons 24h/24 pour vos <strong>livraisons de marchandises froides et sèches</strong> dans tout le <strong>Val-de-Marne (94)</strong>. Professionnels du MIN, grossistes, restaurateurs : profitez d'un service clé en main avec <strong>utilitaire grand volume</strong> et chauffeur expérimenté. Tournées régulières B2B disponibles avec tarifs dégressifs.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="sms:+33632410246?body=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20gratuit%20pour%20un%20transport%20de%20palettes%20à%20Rungis.%20Merci%20de%20me%20recontacter%20avec%20les%20détails%20et%20tarifs.%20Cordialement."
                className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-red-700 hover:to-red-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-3-line text-xl"></i>
                Devis gratuit
              </a>
              <a
                href="tel:+33632410246"
                className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-50 transition-all shadow-lg border-2 border-gray-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                06 32 41 02 46
              </a>
            </div>
          </div>

          {/* Mini Price Simulator */}
          <div className="max-w-4xl mx-auto">
            <MiniPriceSimulator />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Nos Services de Transport de Palettes à Rungis
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Solutions professionnelles adaptées aux besoins du MIN de Rungis et des zones industrielles du Val-de-Marne
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {/* Service 1 */}
            <div className="bg-gradient-to-br from-red-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-red-100">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-stack-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Transport de Palettes
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Tous types de palettes : Europe, standard, perdues ou consignées. Chargement et déchargement sécurisés.
              </p>
              <div className="text-red-600 font-bold text-lg">Dès 49€</div>
            </div>

            {/* Service 2 */}
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-blue-100">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-temp-cold-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Marchandises Froides/Sèches
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Véhicules adaptés pour le transport de produits frais, surgelés et marchandises sèches du MIN.
              </p>
              <div className="text-blue-600 font-bold text-lg">Sur mesure</div>
            </div>

            {/* Service 3 */}
            <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-green-100">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-repeat-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Tournées Régulières B2B
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Contrats de tournées régulières avec tarifs dégressifs pour vos besoins récurrents.
              </p>
              <div className="text-green-600 font-bold text-lg">Tarifs préférentiels</div>
            </div>

            {/* Service 4 */}
            <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-orange-100">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-truck-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Utilitaire Grand Volume
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Véhicules de 12m³ à 20m³ avec hayon élévateur pour vos chargements volumineux.
              </p>
              <div className="text-orange-600 font-bold text-lg">Dès 69€</div>
            </div>
          </div>
        </div>
      </section>

      {/* Zones Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Zones de Livraison depuis Rungis
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Nous couvrons tout le Val-de-Marne et l'Île-de-France pour vos livraisons de palettes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { name: 'Rungis', dept: '94', icon: 'ri-building-line', desc: 'MIN de Rungis, zone industrielle' },
              { name: 'Orly', dept: '94', icon: 'ri-plane-line', desc: 'Aéroport, zones logistiques' },
              { name: 'Thiais', dept: '94', icon: 'ri-store-line', desc: 'Zones commerciales et industrielles' },
              { name: 'Chevilly-Larue', dept: '94', icon: 'ri-map-pin-line', desc: 'Proximité MIN, accès rapide' },
              { name: 'Créteil', dept: '94', icon: 'ri-government-line', desc: 'Préfecture, centre-ville' },
              { name: 'Toute l\'Île-de-France', dept: '75-95', icon: 'ri-road-map-line', desc: 'Livraison express régionale' }
            ].map((zone, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${zone.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">
                      {zone.name} <span className="text-red-600">({zone.dept})</span>
                    </h3>
                    <p className="text-sm text-gray-600">{zone.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Pourquoi nous choisir pour vos transports à Rungis ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-time-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Disponibilité 24h/24</h3>
              <p className="text-gray-600">
                Intervention à tout moment, y compris les horaires d'ouverture matinaux du MIN de Rungis
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-map-2-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Connaissance du MIN</h3>
              <p className="text-gray-600">
                Nos chauffeurs connaissent parfaitement le MIN de Rungis et ses accès
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Marchandises Sécurisées</h3>
              <p className="text-gray-600">
                Véhicules équipés et assurés pour le transport de tous types de marchandises
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-lg text-gray-600">
              Tout ce que vous devez savoir sur notre service de transport de palettes à Rungis
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <details key={index} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden group">
                <summary className="px-6 py-5 cursor-pointer list-none flex items-center justify-between font-bold text-gray-900 hover:bg-gray-50 transition-colors">
                  <span className="text-base lg:text-lg">{faq.question}</span>
                  <i className="ri-arrow-down-s-line text-2xl text-red-600 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-6 pb-5 pt-2 text-gray-600 leading-relaxed border-t border-gray-100">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-red-600 to-red-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=logistics-delivery-truck-on-highway-at-sunset-motion-blur-professional-transportation-service-modern-fleet-dynamic-composition-warm-lighting&width=1920&height=600&seq=rungis-cta-bg&orientation=landscape')] bg-cover bg-center opacity-10"></div>
        
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl lg:text-5xl font-extrabold mb-6">
            Besoin d'un transport de palettes à Rungis ?
          </h2>
          <p className="text-xl lg:text-2xl mb-10 text-red-50">
            Contactez-nous maintenant pour un devis gratuit et une intervention rapide
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="sms:+33632410246?body=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20gratuit%20pour%20un%20transport%20de%20palettes%20à%20Rungis.%20Merci%20de%20me%20recontacter%20avec%20les%20détails%20et%20tarifs.%20Cordialement."
              className="inline-flex items-center gap-2 bg-white text-red-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line text-xl"></i>
              Demander un devis
            </a>
            <a
              href="tel:+33632410246"
              className="inline-flex items-center gap-2 bg-red-800 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-red-900 transition-all shadow-xl border-2 border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              06 32 41 02 46
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}